// Light-weight axios calls for the Gulf sales chatbot.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/chat`;

export const startChat = (funnel = "gulf") =>
  axios.post(`${API}/start`, { funnel }).then((r) => r.data); // { session_id, greeting }

export const sendChat = (session_id, message) =>
  axios.post(`${API}/send`, { session_id, message }).then((r) => r.data); // { reply }
